<ng-container *onlyForScreens="['desktop', 'tablet']">
  <app-dialog-mode-switcher location="export-gallery-dialog" [(mode)]="mode" [modes]="modes">
  </app-dialog-mode-switcher>
  @if (mode === 'filenames') {
  <h2>Copy Filenames</h2>
  } @if (mode === 'pdf') {
  <h2>Save as PDF</h2>
  } @if (mode === 'csv') {
  <h2>Export as CSV</h2>
  }
  <div class="options">
    @if (mode === 'filenames') {
    <form [formGroup]="filenameForm" class="options-row">
      <app-context-menu [options]="{ width: '260px', noSpacing: true }" #menu>
        <button
          appButton
          name="filenames-options"
          location="export-gallery-dialog"
          class="filenames-options"
          contextButton
          [hasIcon]="true"
          shape="small"
          height="3"
        >
          <div class="fake-select-content">
            <div>Options</div>
            <div>{{ getFileNameOptionsText() }}</div>
          </div>
          <app-svg src="/assets/icons/chevron-down.svg" color="grey-50"></app-svg>
        </button>
        <div contextContent class="button-menu">
          <app-radio-button
            [checked]="filenamesOptions.separator === 'comma'"
            [simple]="true"
            activeColor="simple-primary"
            height="3"
            (click)="setSeparator('comma'); menu.close()"
            name="comma-separator"
            location="export-gallery-dialog"
          >
            <div class="multi-line-radio-content">
              <div>Comma Separator</div>
              <div class="extra" [class.selected]="filenamesOptions.separator === 'comma'">Works with Lightroom</div>
            </div>
          </app-radio-button>
          <app-radio-button
            [checked]="filenamesOptions.separator === 'or'"
            [simple]="true"
            activeColor="simple-primary"
            height="3"
            (click)="setSeparator('or'); menu.close()"
            name="or-separator"
            location="export-gallery-dialog"
          >
            <div class="multi-line-radio-content">
              <div>OR Separator</div>
              <div class="extra" [class.selected]="filenamesOptions.separator === 'or'">Works with Mac & Windows</div>
            </div>
          </app-radio-button>
          <app-radio-button
            [checked]="filenamesOptions.separator === 'space'"
            [simple]="true"
            activeColor="simple-primary"
            height="3"
            (click)="setSeparator('space'); menu.close()"
            name="space-separator"
            location="export-gallery-dialog"
          >
            <div class="multi-line-radio-content">
              <div>No Separator</div>
              <div class="extra" [class.selected]="filenamesOptions.separator === 'space'">Works with Capture One</div>
            </div>
          </app-radio-button>
          <div class="divider"></div>
          <label
            for="include-quotes"
            appButton
            name="toggle-quotes"
            location="export-gallery-dialog"
            class="toggle-quotes"
            color="simple"
            [hasIcon]="true"
          >
            <div class="multi-line-radio-content">
              <div>Add Quotes</div>
              <div class="extra">Required for some apps</div>
            </div>
            <div class="switch small" appTransitionPreventor>
              <input type="checkbox" id="include-quotes" formControlName="quotes" (ngModelChange)="calcOutput()" />
              <label for="include-quotes"></label>
            </div>
          </label>
        </div>
      </app-context-menu>
      <app-input-field class="headless" [control]="filenameForm.controls.extension">
        <label>Add Extension</label>
        <!-- eslint-disable-next-line @angular-eslint/template/no-autofocus -->
        <input type="hidden" autofocus="true" />
        <input type="text" formControlName="extension" (ngModelChange)="calcOutput()" />
        <button
          appButton
          name="extension-info"
          location="export-gallery-dialog"
          *appInputPost
          [iconButton]="true"
          appTooltip
          [skipDelay]="true"
          [tooltipHtmlContent]="
            'Add the correct file extension for improved search results.<br><br>Pro Tip: Type * to show the uploaded file extension.'
          "
          color="simple-gray-50"
        >
          <app-svg src="/assets/icons/info-outline.svg"></app-svg>
        </button>
      </app-input-field>
    </form>
    } @if (mode === 'pdf') {
    <div class="export-preview-container">
      <div class="export-preview">
        <img src="/assets/icons/special/export-{{ thumbnailSize }}.svg" alt="" />
      </div>
      <div class="export-preview-options">
        <div class="options-group">
          <h3 class="options-title">Include</h3>
          <div class="group-radios">
            @for (option of pdfIncludeOptions; track option) {
            <app-radio
              [checkStyle]="'check'"
              [checked]="enabledPdfIncludeOptions[option]"
              (click)="togglePdfInclude(option)"
            >
              {{ option | capitalize }}
            </app-radio>
            }
          </div>
        </div>
        <div class="options-group">
          <h3 class="options-title">Thumbnails</h3>
          <div class="group-radios single-row">
            <app-radio [checkStyle]="'radio'" [checked]="thumbnailSize === 'small'" (click)="setThumbnail('small')">
              Small
            </app-radio>
            <app-radio [checkStyle]="'radio'" [checked]="thumbnailSize === 'medium'" (click)="setThumbnail('medium')">
              Medium
            </app-radio>
            <app-radio [checkStyle]="'radio'" [checked]="thumbnailSize === 'large'" (click)="setThumbnail('large')">
              Large
            </app-radio>
          </div>
        </div>
      </div>
    </div>
    } @if (mode === 'csv') {
    <div class="export-preview-container">
      <div class="export-preview">
        <img src="/assets/icons/special/export-csv.svg" alt="" />
      </div>
      <div class="export-preview-options">
        <div class="options-group">
          <h3 class="options-title">Include</h3>
          <div class="group-radios">
            @for (option of csvIncludeOptions; track option) {
            <app-radio
              [checkStyle]="'check'"
              [checked]="enabledCsvIncludeOptions[option]"
              (click)="toggleCsvInclude(option)"
            >
              {{ option | capitalize }}
            </app-radio>
            }
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  <div class="export-content">
    @if (mode === 'filenames') {
    <div class="filenames">
      <div class="copy-content">
        <div class="copy-content-inner">
          {{ filenamesContent }}
        </div>
      </div>
      @if (containsSpaces) {
      <div class="warning-message">
        <app-svg src="/assets/icons/16/alert.svg"></app-svg>
        <span>Some filenames contain spaces which won't work in some applications.</span>
      </div>
      }
      <button
        appButton
        name="copy"
        location="export-gallery-dialog"
        color="primary"
        [copy-clipboard]="filenamesContent"
        (click)="onFilenamesCopied()"
        size="3"
        weight="bold"
        spacing="full"
      >
        Copy Filenames
      </button>
    </div>
    } @if (mode === 'csv') {
    <div class="csv">
      <button
        appButton
        name="csv"
        location="export-gallery-dialog"
        color="primary"
        (click)="exportCsv()"
        size="3"
        weight="bold"
        spacing="full"
      >
        Export CSV
      </button>
    </div>
    } @if (mode === 'pdf') {
    <div class="pdf">
      <button
        appButton
        name="print"
        location="export-gallery-dialog"
        color="primary"
        (click)="print()"
        size="3"
        weight="bold"
        spacing="full"
      >
        Save PDF
      </button>
    </div>
    }
  </div>
  @if (export === 'selection') {
  <div class="selection-info standard-text">
    You’re @if (mode === 'filenames') {
    <span>copying</span>
    } @if (mode !== 'filenames') {
    <span>exporting</span>
    }
    {{ assets?.length }} of {{ allAssets?.length }} assets.
    <a class="primary-link" (click)="setExport('everything')">Reset Selection</a>
  </div>
  } @if (export === 'everything') {
  <div class="selection-info standard-text">
    You’re @if (mode === 'filenames') {
    <span>copying</span>
    } @if (mode !== 'filenames') {
    <span>exporting</span>
    } all {{ allAssets?.length }} assets.
  </div>
  }
</ng-container>
<ng-container *onlyForScreens="['mobile']">
  <div class="dialog">
    <app-svg class="big-icon" src="/assets/icons/64/info.svg" size="2"></app-svg>
    <h1>Use Your Desktop</h1>
    <p>This view is too tight and not optimized for mobile screens. Please use your desktop.</p>
    <button
      appButton
      name="mobile-ok"
      location="export-gallery-dialog"
      color="primary"
      (click)="close()"
      height="4"
      size="3"
      weight="bold"
      spacing="full"
    >
      Ok
    </button>
  </div>
</ng-container>
